import React, { useState, useEffect } from "react";
import moment from "moment";
import {
  Row,
  Col,
  Form,
  Card,
  CardBody,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import CustomDatepicker from "../CustomDatepicker";
import InputText from "../InputText";
import CartTitle from "../CartTitle";
import Loader from "../Loader";
import CustomButton from "../CustomButton";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { fetchQueryParams } from "../../utils/comman";
import { vinValidation } from "../../utils/helperFunction";

import get from "lodash/get";

const _ = { get };

const initialState = {
  purchaceDate: "",
  motorCycle: "",
  varient: [],
  varientId: "",
  varientColor: "",
  regNumber: "",
  vin: "",
  userID: "",
  userGUID: "",
  cluster: "",
  otherMotorcycle: [],
  addVarient: "",
};
export default function vehicleOnBoarding(props) {
  let { elements } = props;

  const [state, setState] = useState(initialState);

  useEffect(() => {
    console.log("VEhicle onboard", props);
    const params = fetchQueryParams(props.query);
    state.cluster = params.cluster;
    state.userID = params.id;
    state.userGUID = params.guid;
    setState({ ...state });
    props.handleFetchMotorCycle("uk");
  }, []);

  const handlePurchaceDateChange = (date) => {
    state.purchaceDate = date;
    setState({ ...state });
  };

  const handleNameChange = (e) => {
    state[e.target.name] = e.target.value;
    setState({ ...state });
  };

  const handleVarientChange = (e) => {
    state.addVarient = e.target.value;
    setState({ ...state });
  };

  const handleChangeMotorCycle = (e) => {
    if (e.target.value !== "Select Motorcycle") {
      let value = JSON.parse(e.target.value);
      state.motorCycle = value.motorcycleName;
      var arrayName = Object.assign([], value.models);
      arrayName.push({ variantName: "Other" });
      state.varient = arrayName;
      state.varientId = "";
      state.varientColor = "";
      setState({ ...state });
    } else {
      state.motorCycle = "";
      state.varientId = "";
      state.varientColor = "";
      state.varient = [];
      setState({ ...state });
    }
  };

  const handleChangeVarient = (e) => {
    if (e.target.value !== "Select Variant") {
      let value = JSON.parse(e.target.value);
      state.varientId =
        value.variantName !== "Other" ? value.motorcycleModelId : "";
      state.varientColor = value.variantName;
      setState({ ...state });
    } else {
      state.varientId = "";
      state.varientColor = "";
      setState({ ...state });
    }
  };

  useEffect(() => {
    var arrayName = Object.assign([], props.motorCycle);
    arrayName.push({ motorcycleName: "Other" });
    state.otherMotorcycle = arrayName;
    setState({ ...state });
  }, [props.motorCycle]);

  const handleSumbit = (e) => {
    e.preventDefault();

    let prevFlag = window.sessionStorage.getItem("prevFlag");
    let data = {
      dateOfMfg: moment(state.purchaceDate).format("YYYY-MM-DD"),
      vehicleModelName: state.motorCycle,
      vehicleModelCode: state.varientId,
      vehicleModelColor:
        state.varientColor && state.varientColor !== "Other"
          ? state.varientColor
          : state.addVarient,
      regNumber: state.regNumber ? state.regNumber.trim() : "",
      vin: state.vin ? state.vin.trim() : "",
      userID: state.userID,
      userGUID: state.userGUID,
      cluster: state.cluster,
    };

    if (state.motorCycle === "")
      return toast.error(
        _.get(
          elements,
          "vehicleOnBoardingElements.selectMotorCycleValidationElement",
          "Select motorcycle"
        )
      );
    if (state.regNumber === "")
      return toast.error(
        _.get(
          elements,
          "vehicleOnBoardingElements.regNumberValidationElement",
          "Enter Registration number"
        )
      );
    if (!vinValidation.test(state.regNumber))
      return toast.error(
        _.get(
          elements,
          "vehicleOnBoardingElements.regValidationElement",
          "Registration number should be alphanumeric"
        )
      );
    // if (state.vin === "")
    //   return toast.error(
    //     _.get(
    //       elements,
    //       "vehicleOnBoardingElements.vinValidationElement",
    //       "Enter VIN"
    //     )
    //   );
    if (state.vin !== "") {
      if (!vinValidation.test(state.vin))
        return toast.error(
          _.get(
            elements,
            "memberShipDetailElements.vinValidationElement",
            "VIN should be alphanumeric"
          )
        );
      if (state.vin.length < 17)
        return toast.error(
          _.get(
            elements,
            "vehicleOnBoardingElements.vinCharValidationElement",
            `Please enter a valid VIN code.
            It should have 17 digits and should not contain symbols`
          )
        );
    }
    if (state.purchaceDate === "")
      return toast.error(
        _.get(
          elements,
          "vehicleOnBoardingElements.purchaseDateValidationElement",
          "Select Purchase date"
        )
      );

    if (prevFlag === "detail")
      return props.handlePendingVehicleOnboarding(data);

    return props.handleVechicleOnboarding(data);
  };

  return (
    <div className="hideSearch">
      {props.motorCycle && props.vechicleOnboardingStatus !== false ? (
        <Loader />
      ) : null}
      <Form onSubmit={handleSumbit}>
        <Row>
          <Col sm={12}>
            <CartTitle
              title={_.get(
                elements,
                "vehicleOnBoardingElements.headingElement",
                "Vehicle Application"
              )}
              customClass={"hidebtn"}
              innerTextClass={"hidetext"}
              iconClass={"hideexcel"}
            />
          </Col>
        </Row>
        <Card className="mb-3">
          <CardBody>
            <Row>
              <Col md="12">
                <h3 className="title-bar secondary-title f-weight-bold mb-3 pb-2 themeColor">
                  {_.get(
                    elements,
                    "vehicleOnBoardingElements.subHeadingElement",
                    "Vehicle"
                  )}
                </h3>
              </Col>
              <Col xl={3} lg={4} md={6} sm={6} className="mb-2">
                <Label className="inputLabel">
                  {_.get(
                    elements,
                    "vehicleOnBoardingElements.motorCycleLabel",
                    "Motorcycle*"
                  )}
                </Label>
                <FormGroup className="mt-1 pt-1">
                  <Input
                    type="select"
                    name="City"
                    className="w-100 customeSelectBtn"
                    onChange={handleChangeMotorCycle}
                  >
                    <option disabled="true" selected="true">
                      {_.get(
                        elements,
                        "vehicleOnBoardingElements.selectMotorCycleElement",
                        "Select Motorcycle"
                      )}
                    </option>
                    {state.otherMotorcycle.map((item, index) => (
                      <option key={index} value={JSON.stringify(item)}>
                        {item.motorcycleName}
                      </option>
                    ))}
                  </Input>
                </FormGroup>
              </Col>
              {state.motorCycle !== "Other" ? (
                <Col xl={3} lg={4} md={6} sm={6} className="mb-2">
                  <Label className="inputLabel">
                    {_.get(
                      elements,
                      "vehicleOnBoardingElements.variantLabel",
                      "Variant*"
                    )}
                  </Label>
                  <FormGroup className="mt-1 pt-1">
                    <Input
                      type="select"
                      name="City"
                      className="w-100 customeSelectBtn"
                      onChange={handleChangeVarient}
                    >
                      <option disabled="true" selected="true">
                        {state.varientId !== ""
                          ? state.varientColor
                          : _.get(
                              elements,
                              "vehicleOnBoardingElements.selectVariantElement",
                              "Select Variant"
                            )}
                      </option>
                      {state.varient &&
                        state.varient.map((item, index) => (
                          <option key={index} value={JSON.stringify(item)}>
                            {item.variantName}
                          </option>
                        ))}
                    </Input>
                  </FormGroup>
                </Col>
              ) : (
                <Col xl={3} lg={4} md={6} sm={6} className="mb-2">
                  <InputText
                    labelName={_.get(
                      elements,
                      "vehicleOnBoardingElements.addNewVariantLabel",
                      "Add New Variant"
                    )}
                    inputType={"text"}
                    inputName={"variantName"}
                    InputClass={"my-2 inputText"}
                    inputPlaceholder={_.get(
                      elements,
                      "vehicleOnBoardingElements.addNewVariantPlaceholder",
                      "Add Variant"
                    )}
                    customOnChange={(e) => handleVarientChange(e)}
                  />
                </Col>
              )}
              {state.varientColor === "Other" ? (
                <Col xl={3} lg={4} md={6} sm={6} className="mb-2">
                  <InputText
                    labelName={_.get(
                      elements,
                      "vehicleOnBoardingElements.addNewVariantLabel",
                      "Add New Variant"
                    )}
                    inputType={"text"}
                    inputName={"variantName"}
                    InputClass={"my-2 inputText"}
                    inputPlaceholder={_.get(
                      elements,
                      "vehicleOnBoardingElements.addNewVariantPlaceholder",
                      "Add Variant"
                    )}
                    customOnChange={(e) => handleVarientChange(e)}
                  />
                </Col>
              ) : null}

              <Col xl={3} lg={4} md={6} sm={6} className="mb-2">
                <InputText
                  labelName={_.get(
                    elements,
                    "vehicleOnBoardingElements.registrationNumberLabel",
                    "Registration Number*"
                  )}
                  inputType={"text"}
                  inputName={"regNumber"}
                  InputClass={"my-2 inputText"}
                  inputPlaceholder={_.get(
                    elements,
                    "vehicleOnBoardingElements.registrationNumberPlaceholder",
                    "Enter Registration Number"
                  )}
                  customValue={state.regNumber}
                  customMaxLength={15}
                  customOnChange={(e) => handleNameChange(e)}
                />
              </Col>
              <Col xl={3} lg={4} md={6} sm={6} className="mb-2">
                <InputText
                  labelName={_.get(
                    elements,
                    "vehicleOnBoardingElements.vinLabel",
                    "VIN*"
                  )}
                  inputType={"text"}
                  inputName={"vin"}
                  InputClass={"my-2 inputText"}
                  customValue={state.vin}
                  customMaxLength={17}
                  inputPlaceholder={_.get(
                    elements,
                    "vehicleOnBoardingElements.vinPlaceholder",
                    "Enter VIN"
                  )}
                  customOnChange={(e) => handleNameChange(e)}
                />
              </Col>

              <Col xl={3} lg={4} md={6} sm={6} className="mb-2">
                <Label className="inputLabel">
                  {_.get(
                    elements,
                    "vehicleOnBoardingElements.dateOfPurchaseLabel",
                    "Date Of Purchase*"
                  )}
                </Label>
                <FormGroup className="mt-1 pt-1">
                  <CustomDatepicker
                    value={state.purchaceDate}
                    customPlaceHolder={_.get(
                      elements,
                      "vehicleOnBoardingElements.dateOfPurchasePlaceholder",
                      "Purchase Date"
                    )}
                    handleDateChange={handlePurchaceDateChange}
                    customShowMonthDropdown={true}
                    customShowYearDropdown={true}
                    customMaxDate={moment().toDate()}
                  />
                </FormGroup>
              </Col>
            </Row>
            <div className="d-flex justify-content-center justify-content-lg-end position-relative ">
              <CustomButton
                customType={"submit"}
                name={_.get(
                  elements,
                  "vehicleOnBoardingElements.submitButtonElement",
                  "Submit"
                )}
                customClass={"btn-outline-dark bg-none ml-2 btnthemeColor"}
              />
            </div>
          </CardBody>
        </Card>
      </Form>
    </div>
  );
}
